export const setUserName = (dataset, i) => {
  if (dataset[i]?.first_name && dataset[i]?.name) {
    return `${dataset[i]?.first_name} ${dataset[i]?.name}`;
  } else if (dataset[i]?.display_name) {
    return dataset[i]?.display_name;
  }
  return dataset[i]?.email || '';
};
